(function() {
  const $onpageNavigations = document.querySelectorAll('.onpage-navigation');

  $onpageNavigations.forEach(($onpageNavigation) => {
    if (window.innerWidth < 768) {
      $onpageNavigation.open = false;
    }
  });
}());
